import { render, staticRenderFns } from "./mainBottomPage.vue?vue&type=template&id=5d437980&scoped=true&"
import script from "./mainBottomPage.vue?vue&type=script&lang=js&"
export * from "./mainBottomPage.vue?vue&type=script&lang=js&"
import style0 from "./mainBottomPage.vue?vue&type=style&index=0&id=5d437980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d437980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d437980')) {
      api.createRecord('5d437980', component.options)
    } else {
      api.reload('5d437980', component.options)
    }
    module.hot.accept("./mainBottomPage.vue?vue&type=template&id=5d437980&scoped=true&", function () {
      api.rerender('5d437980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/mainBottomPage.vue"
export default component.exports